import React, { useState, useRef } from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MultiCompanySelect from '../selectors/company/MultiCompanySelect';
import { SFiltersPanel } from '@avalara/skylab-sdk/react';
import { UserRoleEnum } from '../../utils/enums';
import getClientConfig from '../../utils/getClientConfig';

const FiltersPanelWrapper = (props) => {

    const multiCompanySelectRef = useRef();
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);

    const closeFilterPanel = () => {
        props.onDismiss();
    }

    const onCompanySelectionHandler = (e) => {
        let companies = selectedCompanies.slice();
        companies.push(e.value);
        setSelectedCompanies(companies);
    }

    const onCompanyDeselectionHandler = (e) => {
        let companies = selectedCompanies.filter(t => t !== e.value);
        setSelectedCompanies(companies);
    }

    const onRoleSelectionHandler = (e) => {
        if (e.target.checked) {
            let roles = selectedRoles.slice();
            roles.push(e.target.value);
            setSelectedRoles(roles);
        } else if (!e.target.checked) {
            let roles = selectedRoles.filter(t => t !== e.target.value);
            setSelectedRoles(roles);
        }
    }

    const setFilteringValues = () => {
        props.setFilteringConfig({ companies: selectedCompanies, roles: selectedRoles });
    }

    const resetFilteringValues = () => {
        props.setFilteringConfig({ companies: [], roles: [] });
        setSelectedCompanies([]);
        setSelectedRoles([]);
        multiCompanySelectRef.current?.reset();
    }

    const enableReportingUserRole = getClientConfig().featureFlags?.EnableReportingUserRole;

    return (
        <div>
            <SFiltersPanel
                open={props.open}
                className="mr30"
                onS-dismiss={closeFilterPanel}
                onS-reset={resetFilteringValues}
                onS-apply={setFilteringValues}
            >
                <div slot="filters-panel-content">
                    <div className="full-width mb10" >
                        <label><LanguageStringResolver string='UserManagementFilterCompany' /></label>
                        <MultiCompanySelect
                            ref={multiCompanySelectRef}
                            showSelectionCount={false}
                            selectionHandler={onCompanySelectionHandler}
                            deselectionHandler={onCompanyDeselectionHandler}
                            disabled={false}
                            allCompanyOptions={props.allCompanyOptions}
                        />
                    </div>
                    <div className="full-width mb10" >
                        <label><LanguageStringResolver string='UserManagementFilterRole' /></label>
                        <s-box class={selectedRoles.includes(UserRoleEnum.PREPARER.value) ? "toggle-checkbox" : ""}>
                            <fieldset>
                                <input
                                    id="preparer-checkbox"
                                    type="checkbox"
                                    data-testid="preparer-checkbox"
                                    value={UserRoleEnum.PREPARER.value}
                                    checked={selectedRoles.includes(UserRoleEnum.PREPARER.value)}
                                    onChange={onRoleSelectionHandler}
                                />
                                <label className="checkbox bold pl33" htmlFor="preparer-checkbox"><LanguageStringResolver string='Preparers' /></label>
                            </fieldset>
                        </s-box>
                        { enableReportingUserRole ? <s-box class={selectedRoles.includes(UserRoleEnum.REPORTING_USER.value) ? "toggle-checkbox" : ""}>
                            <fieldset>
                                <input
                                    id="reporting-user-checkbox"
                                    type="checkbox"
                                    data-testid="reporting-user-checkbox"
                                    value={UserRoleEnum.REPORTING_USER.value}
                                    checked={selectedRoles.includes(UserRoleEnum.REPORTING_USER.value)}
                                    onChange={onRoleSelectionHandler}
                                />
                                <label className="checkbox bold pl33" htmlFor="reporting-user-checkbox"><LanguageStringResolver string='ReportingUsers' /></label>
                            </fieldset>
                        </s-box> : null }
                        <s-box class={selectedRoles.includes(UserRoleEnum.ADMIN.value) ? "toggle-checkbox" : ""} >
                            <fieldset>
                                <input
                                    id="admin-checkbox"
                                    type="checkbox"
                                    data-testid="admin-checkbox"
                                    value={UserRoleEnum.ADMIN.value}
                                    checked={selectedRoles.includes(UserRoleEnum.ADMIN.value)}
                                    onChange={onRoleSelectionHandler}
                                />
                                <label className="checkbox bold pl33" htmlFor="admin-checkbox"><LanguageStringResolver string='Administrators' /></label>
                            </fieldset>
                        </s-box>
                    </div>
                </div>
            </SFiltersPanel>
        </div>
    );
}

export default FiltersPanelWrapper;